let _ = require('lodash');
let { cut } = require('../../../../../helpers/utils');
let css = require('./text-filter.css');
let { filterOrdersListByText, setTextFilterValue } = require('../../../../../signals/account/orders-list');
let minLength = 2;

let SELECTOR_FILTER = cut(css.filter);

class Filter {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }

    bind () {
        this.initFilter();
        return {
            input: {
                [SELECTOR_FILTER]: _.debounce(this.filterChange, 500)
            }
        };
    }

    initFilter() {
        this.$context.signal(setTextFilterValue,
            { id:'managerOrderTextFilter', path: ['account', 'orders', 'list', 'filterText'] });
    }

    filterChange (e) {
        e.stopPropagation();
        let textFilterValue = e.currentTarget.value;
        this.$context.signal(filterOrdersListByText, { textFilterValue, minLength });
    }
}

module.exports = {
    constructor: Filter
};



// WEBPACK FOOTER //
// ./components/account/orders/orders-navigation/text-filter/index.js